import apiClient from '../api';

export async function listOpenAmericanas() {
    const { data } = await apiClient.get('/americanas/open');
    return data;
}

export async function listArchivedAmericanas() {
    const { data } = await apiClient.get('/americanas/archived');
    return data;
}

export async function createAmericana(body) {
    const { data } = await apiClient.post('/americanas', body);
    return data;
}

export async function listRegistrations(americanaId) {
    const { data } = await apiClient.get(`/americanas/${americanaId}/registrations`);
    return data;
}

export async function getAmericana(americanaId) {
    const { data } = await apiClient.get(`/americanas/${americanaId}`);
    return data;
}

export async function updateAmericana(americanaId, body) {
    const { data } = await apiClient.put(`/americanas/${americanaId}`, body);
    return data;
}

export async function deleteAmericana(americanaId) {
    await apiClient.delete(`/americanas/${americanaId}`);
}

export async function registerPlayer(americanaId, playerId, status) {
    const payload = { playerId };
    if (status) payload.status = status;
    const { data } = await apiClient.post(`/americanas/${americanaId}/registrations`, payload);
    return data;
}

export async function removeRegistration(americanaId, playerId) {
    await apiClient.delete(`/americanas/${americanaId}/registrations/${playerId}`);
}

export async function removeRegistrationById(americanaId, registrationId) {
    const { data } = await apiClient.delete(`/americanas/${americanaId}/registrations/${registrationId}`);
    return data;
}

export async function listPairs(americanaId) {
    const { data } = await apiClient.get(`/americanas/${americanaId}/pairs`);
    return data;
}

export async function assignPairs(americanaId, pairs) {
    await apiClient.post(`/americanas/${americanaId}/pairs`, {
        americanaId,
        pairs
    });
}

export async function listPlayers() {
    const { data } = await apiClient.get('/players');
    return data;
}

export async function autoAssignPairs(americanaId, numCourts, shuffleSeed) {
     const { data } = await apiClient.post(`/americanas/${americanaId}/assign`, {
        numCourts,
        shuffleSeed
    });
     console.log(data);
     return data;
}

export async function removeCourt(americanaId, court) {
    await apiClient.delete(`/americanas/${americanaId}/courts/${court}`);
}

export async function addAmericanaGuest(americanaId, guest) {
    const payload = {
        firstName: guest.firstName,
        lastName: guest.lastName,
        phone: guest.phone,
        level: guest.level,
    };
    if (guest.status) {
        payload.status = guest.status;
    }
    const { data } = await apiClient.post(`/americanas/${americanaId}/guests`, payload);
    return data;
}
